import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

const makeActive = {
  id: "makeActive",
  icon: UnarchiveOutlinedIcon,
};
const makeUnActive = {
  id: "makeUnActive",
  icon: ArchiveOutlinedIcon,
};
const initials = {
  id: "initials",
  icon: AccountCircleOutlinedIcon,
};
const testDevice = {
  id: "testDevice",
  icon: BuildOutlinedIcon,
};

export default function clientOptions(client) {
  let options = [initials];
  if (client?.active === 1) options.push(makeUnActive);
  if (client?.active === 0) options.push(makeActive);
  if (client?.writeAccess === 1 && client?.unregistered === 0)
    options.push(testDevice);
  return options;
}
